<script>
import Footer from "../Footer.svelte";

let white = true;

</script>
<style>

    .header-section {
        padding: var(--spacingXXXLarge) var(--spacingXXLarge);
    }

    .wrapper {
        margin: auto;
    }

    .header-section .wrapper {
        max-width: 800px;
    }

    .content-section, .footer-section {
        padding: var(--spacingXXLarge);
    }

    .footer-section .wrapper {
        max-width:530px;
    }

    .header-section, .footer-section {
        background-color: var(--colorBgVariant);
    }

</style>

<!-- This is a template file, and the slots will be filled with info from separate files where the template is called on.
    The "missing" spans will only be shown if a slot content has not been defined on a separate page. -->

<div class="header-section">
    <div class="wrapper">
        <slot name="header-section">
			<span class="missing">Titel på sida</span>
		</slot>
    </div>
</div>

<div class="content-section">
    <div class="wrapper">
        <slot name="content-section">
			<span class="missing">Sidans innehåll</span>
		</slot>
    </div>
</div>

<div class="footer-section">
    <div class="wrapper">
        <slot name="footer-section">
			<span class="missing">Extra information</span>
		</slot>
    </div>
</div>

{#if false}
    <slot></slot>
    <!--This is only to get rid of warning about default slot missing-->
{/if}

<Footer {white} />